export enum CustomerTypeEnum {
  PERSON = 'PERSON',
  ORGANISATION = 'ORGANISATION',
}
